<div class="onboarding-container">
  <!-- Header -->
  <div class="onboarding-header">
    <div class="header-top">
      <h1>{{ '::Onboarding:Title' | abpLocalization }}</h1>
      <div class="header-right">
        <div class="step-counter">{{ currentStep + 1 }} / {{ steps.length }}</div>
        <p-button
          [disabled]="disabledBtn"
          styleClass="p-button-rounded p-button-icon p-button-secondary"
          (click)="close()"
        >
          <img src="assets/images/icon/svg/i_times-black.svg" alt="" />
        </p-button>
      </div>
    </div>
    <p-progressBar
      [value]="(currentStep + 1) * (100 / steps.length)"
      [showValue]="false"
    ></p-progressBar>
  </div>
  <!-- Content -->
  <div class="onboarding-content">
    <div class="step-header">
      <div class="step-icon">
        <i
          class="icon pi"
          [ngClass]="{
            'pi-user': steps[currentStep].component === 'profile',
            'pi-map-marker': steps[currentStep].component === 'address',
            'pi-shopping-cart': steps[currentStep].component === 'wishlist',
            'pi-share-alt': steps[currentStep].component === 'share'
          }"
        ></i>
      </div>
      <div class="step-text">
        <h2>{{ steps[currentStep].title }}</h2>
        <p>{{ steps[currentStep].subtitle }}</p>
      </div>
    </div>

    <!-- Dynamic Step Content -->
    <div class="step-content" [ngSwitch]="steps[currentStep].component">
      <ng-container *ngSwitchCase="'profile'">
        <form [formGroup]="profileForm" class="profile-form">
          <div class="form-row">
            <div class="form-group">
              <div class="d-flex justify-content-between align-items-center">
                <dft-label-validation
                  class="f-s-14 f-w-500 color-111"
                  [title]="'::Setting:AccountSetting:Name:Label' | abpLocalization"
                  [titleValidate]="'::Common:Public' | abpLocalization"
                ></dft-label-validation>
                <span class="text-end character-count">
                  {{ getCharacterCount('displayName') }}/ {{ getMaxLength('displayName') }}
                </span>
              </div>
              <span class="p-input-icon-right m-t-7">
                <input
                  type="text"
                  pInputText
                  formControlName="displayName"
                  placeholder="{{ '::Onboarding:Profile:Name:Placeholder' | abpLocalization }}"
                  [maxLength]="getMaxLength('displayName')"
                  autocomplete="off"
                />
              </span>
              <dft-validation [control]="profileForm.get('displayName')"></dft-validation>
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-between align-items-center">
                <dft-label-validation
                  class="f-s-14 f-w-500 color-111"
                  [title]="'::Setting:AccountSetting:AccountName:Label' | abpLocalization"
                  [titleValidate]="'::Common:Public' | abpLocalization"
                ></dft-label-validation>
                <span class="text-end character-count" >
                  {{ getCharacterCount('username') }}/ {{ getMaxLength('username') }}
                </span>
              </div>
              <span class="p-input-icon-right p-input-icon-left m-t-7">
                <input
                  type="text"
                  pInputText
                  formControlName="username"
                  placeholder="@username"
                  (blur)="checkAccountName($event)"
                  [maxLength]="getMaxLength('username')"
                  autocomplete="off"
                />
              </span>
              <dft-validation [control]="profileForm.get('username')"></dft-validation>
              <small>{{ '::Onboarding:Profile:Name:Validation' | abpLocalization }}</small>
            </div>
          </div>
          <div class="media-row m-t-24">
            <div class="media-group">
              <label>{{ '::Onboarding:Media:Avatar:Label' | abpLocalization }}</label>
              <div class="media-input-group">
                <input
                  [accept]="imageAccepts"
                  type="file"
                  accept="image/*"
                  (change)="onAvatarChange($event)"
                  hidden
                  #avatarInput
                />
                <input
                  type="text"
                  class="media-input"
                  [value]="avatarFileName"
                  readonly
                  tabindex="-1"
                  placeholder="{{ '::Onboarding:Media:Placeholder' | abpLocalization }}"
                />
                <button type="button" class="media-btn" (click)="avatarInput.click()">
                  {{ '::Wishlist:Creator:Detail:Choice' | abpLocalization }}
                </button>
              </div>
            </div>
            <div class="media-group">
              <label>{{ '::Onboarding:Media:CoverImg:Label' | abpLocalization }}</label>
              <div class="media-input-group">
                <input
                  [accept]="imageAccepts"
                  type="file"
                  accept="image/*"
                  (change)="onCoverChange($event)"
                  hidden
                  #coverInput
                />
                <input
                  type="text"
                  class="media-input"
                  [value]="coverFileName"
                  readonly
                  tabindex="-1"
                  placeholder="{{ '::Onboarding:Media:Placeholder' | abpLocalization }}"
                />
                <button type="button" class="media-btn" (click)="coverInput.click()">
                  {{ '::Wishlist:Creator:Detail:Choice' | abpLocalization }}
                </button>
              </div>
            </div>
          </div>
          <div class="media">
            <label class="color-111 m-b-7">
              {{ '::Onboarding:Media:Video:Label' | abpLocalization }}</label
            >
            <div class="media-input-group">
              <input
                [accept]="videoAccepts"
                type="file"
                accept="video/*"
                (change)="onVideoChange($event)"
                hidden
                #videoInput
              />
              <input
                type="text"
                class="media-input"
                [value]="videoFileName"
                readonly
                tabindex="-1"
                placeholder="{{ '::Onboarding:Media:Placeholder' | abpLocalization }}"
              />
              <button type="button" class="media-btn" (click)="videoInput.click()">
                {{ '::Wishlist:Creator:Detail:Choice' | abpLocalization }}
              </button>
            </div>
          </div>
          <div class="media-note">{{ '::Onboarding:Note' | abpLocalization }}</div>
        </form>
      </ng-container>
      <ng-container *ngSwitchCase="'address'">
        <form [formGroup]="addressForm" class="address-form">
          <div class="form-group">
            <div class="d-flex justify-content-between align-items-center">
              <label>{{ '::Onboarding:Address:DeliveryAddressName:Label' | abpLocalization }}</label>
              <span class="text-end character-count">
                {{ getCharacterCount('deliveryName', 'addressForm') }}/ 16
              </span>
            </div>
            <input
              type="text"
              class="form-control"
              formControlName="deliveryName"
              placeholder="{{ '::Onboarding:Address:DeliveryAddressName:Placeholder' | abpLocalization }}"
              [maxLength]="16"
              autocomplete="off"
            />
            <dft-validation [control]="addressForm.get('deliveryName')"></dft-validation>
          </div>

          <div class="form-row three-columns">
            <div class="form-group">
              <label>{{ '::Onboarding:Address:PostCode:Label' | abpLocalization }}</label>
              <input
                type="text"
                class="form-control"
                formControlName="postCode"
                placeholder="{{ '::Onboarding:Address:PostCode:Placeholder' | abpLocalization }}"
                OnlyNumbers
                [postCode]="true"
                (change)="onChangePostCode($event)"
                autocomplete="off"
              />
              <dft-validation [control]="addressForm.get('postCode')"></dft-validation>
            </div>

            <div class="form-group">
              <label>{{ '::Onboarding:Address:Prefecture' | abpLocalization }}</label>
              <p-dropdown
                formControlName="prefecture"
                [options]="prefectureOptions"
                optionLabel="displayName"
                optionValue="id"
                placeholder="{{ '::Onboarding:Address:Prefecture' | abpLocalization }}"
                appendTo="body"
                (onChange)="onPrefecturesChange($event.value)"
                type="text"
                class="custom-dropdown w-100 m-t-4"
              ></p-dropdown>
              <dft-validation [control]="addressForm.get('prefecture')"></dft-validation>
            </div>

            <div class="form-group">
              <label>{{ '::Onboarding:Address:Municipalities' | abpLocalization }}</label>
              <input
                type="text"
                class="form-control"
                formControlName="municipality"
                placeholder="{{ '::Onboarding:Address:Municipalities' | abpLocalization }}"
                [maxLength]="100"
                autocomplete="off"
              />
              <dft-validation [control]="addressForm.get('municipality')"></dft-validation>
            </div>
          </div>

          <div class="form-group">
            <div class="d-flex justify-content-between align-items-center">
              <label>{{ '::Onboarding:Address:TownArea/BlockNumber:Label' | abpLocalization }}</label>
              <span class="text-end character-count">
                {{ getCharacterCount('townArea', 'addressForm') }}/ 160
              </span>
            </div>
            <input
              type="text"
              class="form-control"
              formControlName="townArea"
              placeholder="{{
                '::Onboarding:Address:TownArea/BlockNumber:Placeholder' | abpLocalization
              }}"
              [maxLength]="160"
              autocomplete="off"
            />
            <dft-validation [control]="addressForm.get('townArea')"></dft-validation>
          </div>

          <div class="form-group">
            <div class="d-flex justify-content-between align-items-center">
              <label>{{
                '::Onboarding:Address:BuildingName/FloorNumber/RoomNumber:Label' | abpLocalization
              }}</label>
              <span class="text-end character-count" >
                {{ getCharacterCount('buildingName', 'addressForm') }}/ 160
              </span>
            </div>
            <input
              type="text"
              class="form-control"
              formControlName="buildingName"
              placeholder="{{
                '::Onboarding:Address:BuildingName/FloorNumber/RoomNumber:Placeholder'
                  | abpLocalization
              }}"
              [maxLength]="160"
              autocomplete="off"
            />
            <dft-validation [control]="addressForm.get('buildingName')"></dft-validation>
          </div>

          <div class="form-group">
            <label>{{ '::Onboarding:Address:TelephoneNumber:Label' | abpLocalization }}</label>
            <input
              type="tel"
              class="form-control"
              formControlName="telephone"
              placeholder="{{
                '::Onboarding:Address:TelephoneNumber:Placeholder' | abpLocalization
              }}"
              [maxLength]="11"
              autocomplete="off"
              OnlyNumbers
              (blur)="checkPhone($event)"
              (keydown)="onKeyDown($event)"
            />
            <dft-validation [control]="addressForm.get('telephone')"></dft-validation>
          </div>
        </form>
      </ng-container>
      <ng-container *ngSwitchCase="'wishlist'">
        <div class="wishlist-container">
          <div *ngIf="loadingWishlistItems" class="loading-container">
            <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
            <p>{{ '::Onboarding:Wishlist:Loading' | abpLocalization }}</p>
          </div>
          <div *ngIf="!loadingWishlistItems" class="wishlist-grid">
            <div *ngFor="let item of sampleWishlistItems" class="wishlist-item">
              <div
                class="item-container"
                [ngClass]="{ selected: isItemSelected(item.id) }"
                (click)="isItemSelected(item.id) ? toggleWishlistItem(item) : null"
              >
                <div class="checkbox-container" *ngIf="isItemSelected(item.id)">
                  <i class="icon pi pi-check"></i>
                </div>
                <div
                  class="add-button"
                  (click)="toggleWishlistItem(item); $event.stopPropagation()"
                  *ngIf="!isItemSelected(item.id)"
                >
                  <i class="icon pi pi-plus"></i>
                </div>
                <div class="image-container">
                  <img [src]="getImageUrl(item.image)" [alt]="item.title" />
                </div>
                <div class="hover-info">
                  <div class="item-title">{{ item.title }}</div>
                  <div class="item-price">¥{{ item.displayMoney | tienTe }}</div>
                  <div class="item-source">{{ getLinkDomain(item.link) }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Danh sách sản phẩm đã chọn -->
          <div class="selected-items-container" *ngIf="selectedWishlistItems.length > 0">
            <div class="selected-items-header">
              <h4>
                {{
                  '::Onboarding:Wishlist:SelectedItems'
                    | abpLocalization : selectedWishlistItems.length
                }}
              </h4>
            </div>
            <div class="selected-items-list">
              <div *ngFor="let item of selectedWishlistItems" class="selected-item">
                <div class="item-info">
                  <div class="item-name">{{ item.title }}</div>
                  <div class="item-price">¥{{ item.displayMoney | tienTe }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="wishlist-note">
            {{ '::Onboarding:Wishlist:Note' | abpLocalization }}
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'share'">
        <div class="share-container">
          <div class="twitter-share-box">
            <div class="twitter-share-button">
              <button class="x-share-btn" (click)="shareOnTwitter()">
                <img alt="Twitter" src="assets/images/icon/svg/Vector-white.svg" />
                {{ '::Onboarding:Share:Btn' | abpLocalization }}
              </button>
              <div class="twitter-info">
                {{ '::Onboarding:Share:Note' | abpLocalization }}
              </div>
            </div>
          </div>

          <div class="twitter-preview">
            <div class="twitter-card">
              <div class="twitter-header">
                <div class="twitter-avatar">
                  <span class="avatar-text">U</span>
                </div>
                <div class="twitter-user-info">
                  <span class="twitter-username">{{
                    '::Onboarding:Share:GiptTitle' | abpLocalization
                  }}</span>
                  <span class="twitter-handle">@username</span>
                  <span class="twitter-time">・今</span>
                </div>
              </div>

              <div class="twitter-content">
                <div class="twitter-text">
                  <span [innerHTML]=" '::Onboarding:Share:Content' | abpLocalization "></span>
                </div>

                <div class="twitter-link-preview">
                  <div class="link-image-placeholder"></div>
                  <div class="link-content">
                    <div class="link-domain">gi-pt.com</div>
                    <div class="link-title">
                      {{ '::Onboarding:Share:GiptTitle' | abpLocalization }}
                    </div>
                    <div class="link-description">{{ '::Onboarding:Share:LinkDesciption' | abpLocalization }}</div>
                  </div>
                </div>
              </div>

              <div class="twitter-actions">
                <div class="action-item">
                  <i class="pi pi-comment"></i>
                  <span>0</span>
                </div>
                <div class="action-item">
                  <i class="pi pi-sync"></i>
                  <span>0</span>
                </div>
                <div class="action-item">
                  <i class="pi pi-heart"></i>
                  <span>0</span>
                </div>
                <div class="action-item">
                  <i class="pi pi-share-alt"></i>
                  <span>0</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Footer -->
  <div class="onboarding-footer">
    <div class="w-100">
      <p-button
        styleClass="p-button-rounded button-content w-100 button-back"
        (click)="previousStep()"
        [disabled]="currentStep === 0 || disabledBtn"
      >
        <i class="icon icon pi pi-chevron-left"></i>
        {{ '::Onboarding:Btn:Pre' | abpLocalization }}
      </p-button>
    </div>
    <div class="w-100">
      <p-button
        [disabled]="disabledBtn"
        styleClass="p-button-rounded w-100 button-content button-next"
        (click)="nextStep()"
      >
        <ng-container *ngIf="currentStep === steps.length - 1">
          <i class="icon pi pi-check"></i>
          {{ '::Onboarding:Btn:Done' | abpLocalization }}
        </ng-container>
        <ng-container *ngIf="currentStep !== steps.length - 1">
          {{ '::Onboarding:Btn:Next' | abpLocalization }}
          <i class="icon pi pi-chevron-right"></i>
        </ng-container>
      </p-button>
    </div>
  </div>
</div>
